function lazyLoad(view) {
  return () => import(`./${view}.vue`)
}

export default {
  path: '/studentReport',
  props: true,
  component: lazyLoad('StudentReportRoot'),
  children: [
    {
      path: ':session_id',
      name: 'StudentReportView',
      props: true,
      component: lazyLoad('StudentReportView'),
    },
  ],
}
